
import React from 'react';

export const ExpertiseSection: React.FC = () => {
  const teamMembers = [
    {
      name: 'Sarah Johnson',
      title: 'Senior Financial Advisor',
      credentials: 'CFP, CFA',
      experience: '12 years',
      specialties: ['Investment Planning', 'Retirement Strategies', 'Tax Optimization'],
      image: 'https://public.readdy.ai/ai/img_res/fb09c2f41d3f557de7d173e407c83e4e.jpg'
    },
    {
      name: 'Michael Chen',
      title: 'Business Development Director',
      credentials: 'MBA, PMP',
      experience: '15 years',
      specialties: ['Strategic Planning', 'Market Analysis', 'Growth Strategies'],
      image: 'https://readdy.ai/api/search-image?query=Professional%20male%20business%20consultant%20in%20formal%20business%20suit%2C%20confident%20executive%20appearance%2C%20modern%20corporate%20office%20environment%2C%20professional%20headshot%20with%20sophisticated%20lighting%20and%20business%20professional%20styling&width=400&height=500&seq=team-002&orientation=portrait'
    },
    {
      name: 'Emily Rodriguez',
      title: 'Career Development Coach',
      credentials: 'PCC, SHRM-CP',
      experience: '10 years',
      specialties: ['Executive Coaching', 'Leadership Development', 'Career Transitions'],
      image: 'https://readdy.ai/api/search-image?query=Professional%20female%20career%20coach%20in%20business%20attire%2C%20warm%20and%20encouraging%20expression%2C%20modern%20office%20setting%20with%20career%20development%20materials%2C%20professional%20headshot%20with%20natural%20lighting%20and%20approachable%20demeanor&width=400&height=500&seq=team-003&orientation=portrait'
    },
    {
      name: 'David Thompson',
      title: 'Wealth Management Specialist',
      credentials: 'CWM, ChFC',
      experience: '18 years',
      specialties: ['Estate Planning', 'Risk Management', 'Wealth Preservation'],
      image: 'https://readdy.ai/api/search-image?query=Professional%20male%20wealth%20management%20advisor%20in%20premium%20business%20attire%2C%20distinguished%20and%20trustworthy%20appearance%2C%20upscale%20office%20environment%20with%20financial%20documents%2C%20professional%20headshot%20with%20executive%20lighting&width=400&height=500&seq=team-004&orientation=portrait'
    }
  ];

  const certifications = [
    { name: 'Certified Financial Planner', abbr: 'CFP', icon: 'ri-award-line' },
    { name: 'Chartered Financial Analyst', abbr: 'CFA', icon: 'ri-line-chart-line' },
    { name: 'Certified Wealth Manager', abbr: 'CWM', icon: 'ri-money-dollar-circle-line' },
    { name: 'Professional Certified Coach', abbr: 'PCC', icon: 'ri-user-star-line' }
  ];

  return (
    <section id="expertise" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: '"Playfair Display", serif' }}>
            Our <span className="text-blue-600">Expert Team</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Meet our team of certified professionals who bring decades of combined experience in financial planning, 
            business development, and career coaching to help you achieve your goals.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {teamMembers.map((member, index) => (
            <div key={index} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <div className="aspect-w-3 aspect-h-4">
                <img 
                  src={member.image}
                  alt={member.name}
                  className="w-full h-80 object-cover object-top"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-1">{member.name}</h3>
                <p className="text-blue-600 font-semibold mb-2">{member.title}</p>
                <p className="text-sm text-gray-600 mb-3">{member.credentials} • {member.experience}</p>
                
                <div className="space-y-1">
                  {member.specialties.map((specialty, specialtyIndex) => (
                    <div key={specialtyIndex} className="flex items-center text-sm text-gray-700">
                      <i className="ri-check-line text-teal-500 mr-2 text-xs"></i>
                      {specialty}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-white rounded-2xl shadow-lg p-8">
          <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">
            Professional Certifications & Credentials
          </h3>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {certifications.map((cert, index) => (
              <div key={index} className="text-center p-6 border border-gray-200 rounded-xl hover:border-blue-300 transition-colors">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${cert.icon} text-2xl text-blue-600`}></i>
                </div>
                <h4 className="font-bold text-gray-900 mb-2">{cert.abbr}</h4>
                <p className="text-sm text-gray-600">{cert.name}</p>
              </div>
            ))}
          </div>
          
          <div className="mt-8 text-center">
            <p className="text-gray-600 mb-4">
              Our team maintains the highest industry standards through continuous education and professional development.
            </p>
            <div className="flex justify-center space-x-8 text-sm text-gray-500">
              <span>• SEC Registered</span>
              <span>• FINRA Compliant</span>
              <span>• Fiduciary Standard</span>
              <span>• Continuing Education</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
